import React from 'react'
import { Link } from 'react-router-dom'

const VipFooter: React.FC = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>广东凡思彼得科技有限公司</h4>
            <p>企业服务与 AI 资质咨询平台</p>
            <p>本网站内容仅用于企业服务与咨询信息展示，具体服务方案以实际项目评估结果为准。</p>
          </div>
          <div className="footer-col">
            <h4>服务中心</h4>
            <Link to="/vip/services/business-finance">企业工商财税咨询</Link><br/>
            <Link to="/vip/services/intellectual-property">知识产权咨询</Link><br/>
            <Link to="/vip/services/internet-licenses">ICP / EDI 资质咨询</Link><br/>
            <Link to="/vip/services/ai-compliance">AI 算法 / 大模型备案咨询</Link><br/>
            <Link to="/vip/services/content-licenses">网络文化经营许可证 / 广电证咨询</Link>
          </div>
          <div className="footer-col">
            <h4>站点导航</h4>
            <Link to="/vip">首页</Link><br/>
            <Link to="/vip/services">服务中心</Link><br/>
            <Link to="/vip/ai-solutions">AI 解决方案</Link><br/>
            <Link to="/vip/process">办理流程</Link><br/>
            <Link to="/vip/faq">常见问题</Link><br/>
            <Link to="/vip/about">关于我们</Link><br/>
            <Link to="/vip/contact">联系我们</Link>
          </div>
          <div className="footer-col">
            <h4>联系我们</h4>
            <p>邮箱：fancyai4u@outlook.com</p>
            <p>微信：Fancyview4U</p>
            <p>VIP顾问电话咨询：13078096940</p>
          </div>
        </div>
        <div className="copyright">© 2026 广东凡思彼得科技有限公司 版权所有 ｜ 粤ICP备2026035085号</div>
      </div>
    </footer>
  )
}

export default VipFooter
